// Shared constants to avoid circular dependencies

export const APP_NAME = 'Dino';

export const ROUTES = {
  HOME: '/',
  AUTH: '/auth',
  SEARCH: '/search',
  SETTINGS: '/settings',
  PROFILE: '/u/:username',
  BOOK_DETAIL: '/book/:id',
  ONBOARDING: '/onboarding',
  ONBOARDING_IMPORT: '/onboarding/import',
  ONBOARDING_GENRES: '/onboarding/genres',
  WRAPPED: '/wrapped',
  IMPORT: '/import',
  FOCUS: '/focus',
} as const;

// Comprehensive genre list organized by Fiction/Non-Fiction
export const GENRE_OPTIONS = [
  // Fiction
  'Fiction (General / Contemporary)',
  'Literary Fiction',
  'Classics',
  'Romance',
  'Fantasy',
  'Science Fiction',
  'Mystery & Thriller',
  'Crime & Detective',
  'Horror & Gothic',
  'Historical Fiction',
  'Young Adult (YA)',
  'Middle Grade & Children\'s',
  'Graphic Novels & Comics',
  'Short Stories',
  
  // Non-Fiction
  'Memoir & Autobiography',
  'Biography',
  'History',
  'Politics & Current Affairs',
  'Identity & Social Issues',
  'Gender Studies & Feminism',
  'LGBTQ+ Studies',
  'True Crime',
  'Essays & Journalism',
  'Science & Nature',
  'Psychology & Mental Health',
  'Philosophy',
  'Self-Help & Personal Development',
  'Business & Economics',
  'Travel & Adventure',
  'Food & Cooking',
  'Art & Photography',
  'Poetry'
] as const;

// Helper to categorize genres
export const FICTION_GENRES = [
  'Fiction (General / Contemporary)',
  'Literary Fiction',
  'Classics',
  'Romance',
  'Fantasy',
  'Science Fiction',
  'Mystery & Thriller',
  'Crime & Detective',
  'Horror & Gothic',
  'Historical Fiction',
  'Young Adult (YA)',
  'Middle Grade & Children\'s',
  'Graphic Novels & Comics',
  'Short Stories',
] as const;

export const NONFICTION_GENRES = [
  'Memoir & Autobiography',
  'Biography',
  'History',
  'Politics & Current Affairs',
  'Identity & Social Issues',
  'Gender Studies & Feminism',
  'LGBTQ+ Studies',
  'True Crime',
  'Essays & Journalism',
  'Science & Nature',
  'Psychology & Mental Health',
  'Philosophy',
  'Self-Help & Personal Development',
  'Business & Economics',
  'Travel & Adventure',
  'Food & Cooking',
  'Art & Photography',
  'Poetry'
] as const;

export const STORAGE_BUCKETS = {
  IMPORTS: 'imports',
  AVATARS: 'avatars',
  COVERS: 'covers',
  VOICE_NOTES: 'voice_notes',
} as const;

export const FILE_LIMITS = {
  CSV_MAX_SIZE: 20 * 1024 * 1024, // 20MB
  AUDIO_MAX_SIZE: 25 * 1024 * 1024, // 25MB
  IMAGE_MAX_SIZE: 5 * 1024 * 1024, // 5MB
} as const;

export const SEARCH_LANGUAGES = [
  { code: 'eng', label: 'English', flag: '🇬🇧' },
  { code: 'fre', label: 'French', flag: '🇫🇷' },
  { code: 'spa', label: 'Spanish', flag: '🇪🇸' },
  { code: 'ger', label: 'German', flag: '🇩🇪' },
  { code: 'ita', label: 'Italian', flag: '🇮🇹' },
  { code: 'por', label: 'Portuguese', flag: '🇵🇹' },
  { code: 'jpn', label: 'Japanese', flag: '🇯🇵' },
  { code: 'kor', label: 'Korean', flag: '🇰🇷' },
  { code: 'chi', label: 'Chinese', flag: '🇨🇳' },
  { code: 'rus', label: 'Russian', flag: '🇷🇺' },
  { code: 'ara', label: 'Arabic', flag: '🇸🇦' },
  { code: 'dut', label: 'Dutch', flag: '🇳🇱' },
] as const;